import { Util } from '@grandvisionhq/forms';
import { useAdyen } from '@grandvisionhq/payments';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';

const isEmailValid = (email)=>email && Util.validations.isEmailAddress(email)
;
const isPostalCodeValid = (country, postalCode)=>country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode)
;
const useValidatePaymentData = ()=>{
    var ref1;
    const { getLabel  } = useIntl();
    const { featureConfigs , allowAlternativeShippingState  } = useFeatureToggles();
    const { config  } = useAdyen();
    const addressValidation = config === null || config === void 0 ? void 0 : (ref1 = config.googlepay) === null || ref1 === void 0 ? void 0 : ref1.addressValidation;
    return (intermediatePaymentData, isShippingRequired)=>{
        var ref;
        const { shippingAddress , paymentMethodData , email  } = intermediatePaymentData;
        const billingAddress = (ref = paymentMethodData.info) === null || ref === void 0 ? void 0 : ref.billingAddress;
        if (!isEmailValid(email)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.contact.email.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        if (allowAlternativeShippingState && featureConfigs.alternativeShippingRegex) {
            const postalCodeIsInvalid = (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalCode) && featureConfigs.alternativeShippingRegex.test(shippingAddress.postalCode);
            if (postalCodeIsInvalid) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.address.postalCode.unavailable.errorMessage'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
        }
        if (!isPostalCodeValid(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode, billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.address.postalCode.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        if (shippingAddress) {
            if (!isPostalCodeValid(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.countryCode, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalCode)) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.address.postalCode.errorMessage'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
            if ((addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.streetName) && !(addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.streetName((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address1) || ''))) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.address.streetName.errorMessage'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
            if ((addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.fullName) && !(addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.fullName((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.name) || ''))) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.address.fullName.errorMessage'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
            if ((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address2) && (addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.additionalStreetInfo) && !(addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.additionalStreetInfo((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address2) || ''))) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.address.additionalStreetInfo.errorMessage'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
            if ((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address3) && (addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.additionalStreetInfo) && !(addressValidation === null || addressValidation === void 0 ? void 0 : addressValidation.additionalStreetInfo((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address3) || ''))) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.address.additionalStreetInfo.errorMessage'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
        }
        if (isShippingRequired && !shippingAddress) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.address.shipping.required.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        if (!(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.locality)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.address.city.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        if (!(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.phoneNumber)) {
            return {
                isPaymentDataValid: false,
                error: {
                    reason: 'SHIPPING_ADDRESS_INVALID',
                    message: getLabel('checkout.contact.phoneNumber.errorMessage'),
                    intent: 'SHIPPING_ADDRESS'
                }
            };
        }
        return {
            isPaymentDataValid: true
        };
    };
};

export { useValidatePaymentData };
//# sourceMappingURL=use-validate-payment-data.js.map
